import { Grid, InputBase, Typography } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
// Component
import Snackbar from '../snackbar';
import DialogInviteEmployee from './addEmployee';
import ListEmployee from './listEmployee';
import Header from '../../partials/header' 
import { styles } from './styles';

class ServiceAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAddEmployee: false,
      flagOpen: false,
      search: "",
    }
    this.addNewEmployee = this.addNewEmployee.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
  }
  componentDidMount() {
  }
  addNewEmployee() {
    this.props.history.push('/employee/invite')
    // this.DialogInviteEmployee.handleDialogOpen('PopUpEnterPhone')
  }
  handleSearch(event) {
    this.setState({search: event.target.value}, function() {
      this.ListEmployee.getListEmployeeService()
    })
  }
  render() { 
    const { classes, t } = this.props;
    const {search} = this.state;
    return (
      <Fragment>
        <Snackbar
          color='white'
          onRef={snackbar => (this.mSnackbar = snackbar)}
        />
          {/* <DialogInviteEmployee  onRef={dialog => (this.DialogInviteEmployee = dialog)} addSuccess={()=>this.addSuccess()}/> */}
          <Header
              session= {t('sidebar_manage')}
              title= {t('employees_list_employees')} 
              button= {t('employees_add_new_employee')}
              actionButton= {this.addNewEmployee}
          /> 
          <ListEmployee  onRef={id => (this.ListEmployee = id)} search={search}/>
      </Fragment>
    )
  }
}

ServiceAdmin.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
}

const mapState = state => ({
})
const mapDispatch = dispatch => ({ 
  employeeDispatch: dispatch.employees, 
});

export default connect(mapState, mapDispatch)(translate('translations')(withStyles(styles, { withTheme: true })(ServiceAdmin)));